import { render, staticRenderFns } from "./NewsThree.vue?vue&type=template&id=53a314b5&scoped=true&"
import script from "./NewsThree.vue?vue&type=script&lang=ts&"
export * from "./NewsThree.vue?vue&type=script&lang=ts&"
import style0 from "./NewsThree.vue?vue&type=style&index=0&id=53a314b5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a314b5",
  null
  
)

export default component.exports